import "./instrument"; // Sentry must initialize before any other code

import React from 'react';
import ReactDOM from 'react-dom/client';
import { reactErrorHandler } from '@sentry/react';
import './index.css';
import './styles/galette.scss';
import '@mes-amis/super-form/styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker } from './lib/service-worker';
import { initDataEventListener } from './db/event-listener';

// Initialize data event listener for decoupled data layer communication
initDataEventListener();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
  {
    // React 19 error handlers for Sentry
    onUncaughtError: reactErrorHandler(),
    onCaughtError: reactErrorHandler(),
    onRecoverableError: reactErrorHandler(),
  }
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();